import { ROUTES } from "~/constants/routes";
import { navigateTo as nuxtNavigateTo } from "#app";

export function useRoutes() {
    const navigateToRoute = (location: string) => {
        return nuxtNavigateTo({ name: location });
    };

    const navigateToUrl = (url: string) => {
        return nuxtNavigateTo(url);
    };

    const goToHome = () => navigateToRoute(ROUTES.HOME);
    const goToDashboard = () => navigateToRoute(ROUTES.DASHBOARD);
    const goToUserManagement = () => navigateToRoute(ROUTES.AUTH.USER);
    const goToRoleManagement = () => navigateToRoute(ROUTES.AUTH.ROLE);
    const goToPermissionManagement = () => navigateToRoute(ROUTES.AUTH.PERMISSION);
    const goToOrganizationManagement = () => navigateToRoute(ROUTES.AUTH.ORGANIZATION);
    const goToBomList = () => navigateToRoute(ROUTES.BOM.BOMLIST);
    const goToBomCreator = () => navigateToRoute(ROUTES.BOM.BOMCREATOR);
    const goToProductRuleList = () => navigateToRoute(ROUTES.PRODUCT_RULE.LIST);
    const goToBomCollectionView = () => navigateToRoute(ROUTES.BOM.COLLECTION_VIEW);
    const goToBomCollectionEdit = () => navigateToRoute(ROUTES.BOM.COLLECTION_EDIT);
    const goToBomAlternativePart = () => navigateToRoute(ROUTES.BOM.ALTERNATIVE_PART);

    return {
        routes: ROUTES,
        navigateTo: navigateToRoute,
        navigateToUrl,
        goToHome,
        goToDashboard,
        goToUserManagement,
        goToRoleManagement,
        goToPermissionManagement,
        goToOrganizationManagement,
        goToBomList,
        goToBomCreator,
        goToProductRuleList,
        goToBomCollectionView,
        goToBomCollectionEdit,
        goToBomAlternativePart
    };
}
